
      (function() {
        var piwikIdPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
        var piwikEnabled = import.meta.env.VITE_PIWIK_ENABLED;
        var piwikId = import.meta.env.VITE_PIWIK_TAG_MANAGER_ID;

        // XSS prevention: validate ID format before injecting script
        if (piwikEnabled === 'true' && piwikId && piwikIdPattern.test(piwikId)) {
          (function (window, document, dataLayerName, id) {
            window[dataLayerName] = window[dataLayerName] || [];
            window[dataLayerName].push({
              start: new Date().getTime(),
              event: 'stg.start',
            });
            var scripts = document.getElementsByTagName('script')[0],
              tags = document.createElement('script');
            var qP = [];
            dataLayerName !== 'dataLayer' &&
              qP.push('data_layer_name=' + dataLayerName);
            var qPString = qP.length > 0 ? '?' + qP.join('&') : '';
            tags.async = !0;
            tags.src =
              'https://myjobglasses.containers.piwik.pro/' + id + '.js' + qPString;
            scripts.parentNode.insertBefore(tags, scripts);
            !(function (a, n, i) {
              a[n] = a[n] || {};
              for (var c = 0; c < i.length; c++)
                !(function (i) {
                  a[n][i] = a[n][i] || {};
                  a[n][i].api =
                    a[n][i].api ||
                    function () {
                      var a = [].slice.call(arguments, 0);
                      'string' == typeof a[0] &&
                        window[dataLayerName].push({
                          event: n + '.' + i + ':' + a[0],
                          parameters: [].slice.call(arguments, 1),
                        });
                    };
                })(i[c]);
            })(window, 'ppms', ['tm', 'cm']);
          })(window, document, 'dataLayer', piwikId);
        }
      })();
    